/** @jsx jsx */
import { Fragment, useState, useContext } from 'react'
import { jsx, css } from '@emotion/core'
import { Button, ActionModal } from '@livechat/design-system'
import api from '../../api'
import { Context } from '../../context'

import deleteIcon from '../../assets/icons/delete-blue.svg'

const Delete = ({ responseId, surveyId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPending, setIsPending] = useState(false)

  const { surveyToken, removeSurveyResponse } = useContext(Context)

  const onDropSurveyResponse = async () => {
    await api.deleteSurveyResponse(surveyToken, surveyId, responseId)

    removeSurveyResponse(responseId)
  }

  return (
    <div>
      <Button
        type="ghost"
        css={css`
          font-size: 14px;
          width: 85px;
          margin-left: auto;
          margin-top: auto;
        `}
        onClick={() => {
          setIsModalOpen(true)
        }}
      >
        <div
          css={css`
            display: flex;
            margin-left: 5px;
            margin-right: 5px;
          `}
        >
          <img
            src={deleteIcon}
            alt="delete"
            css={css`
              width: 16px;
              margin-right: 3px;
            `}
          />
          <span>Delete</span>
        </div>
      </Button>
      {isModalOpen && (
        <ActionModal
          onClose={() => setIsModalOpen(false)}
          style={{ width: '410px' }}
          heading="Danger!"
          actions={
            <Fragment>
              <Button
                size="large"
                onClick={() => setIsModalOpen(false)}
                secondary
                style={{ marginRight: '15px' }}
              >
                Back
              </Button>
              <Button
                className="delete-btn"
                size="large"
                loading={isPending}
                onClick={async () => {
                  setIsPending(true)
                  await onDropSurveyResponse()
                  setIsPending(false)
                  setIsModalOpen(false)
                }}
                destructive
              >
                Delete response
              </Button>
            </Fragment>
          }
        >
          You’re about to do something that cannot be undone. Are you sure you
          want to delete this response?
        </ActionModal>
      )}
    </div>
  )
}

export default Delete
